import { Nullable } from 'utils/ts-utils'

import EtherScanDark from 'assets/block-explorer-icons/etherscan-dark.png'
import SnowTraceDark from 'assets/block-explorer-icons/snowtrace-dark.png'
import EtherScanLight from 'assets/block-explorer-icons/etherscan-light.png'
import EtherScanHover from 'assets/block-explorer-icons/etherscan-hover.png'
import SnowTraceLight from 'assets/block-explorer-icons/snowtrace-light.png'
import SnowTraceHover from 'assets/block-explorer-icons/snowtrace-hover.png'
import { NetworkType } from 'abis/set/sets'
export interface CustomProviderInfo {
  icon: string
  name: string
}

export const chainHashMap = {
  [NetworkType.Mainnet]: '0x1',
  [NetworkType.Avalanche]: '0xa86a',
}

export const indexName = {
  [NetworkType.Avalanche]: 'CAI',
}

//FIXME: can be deleted in future
export const chainIdMap: { [key: string]: number } = {
  [NetworkType.Mainnet]: 1,
  [NetworkType.Avalanche]: 43114,
}

/**
 * list of acceptable zerox urls for zerox aggr
 */
export const zerExBaseUrl: { [key: string]: string } = {
  [NetworkType.Mainnet]: `https://0x.phuture.finance/api/${NetworkType.Mainnet}`,
  [NetworkType.Avalanche]: `https://0x.phuture.finance/api/${NetworkType.Avalanche}`,
}

export const blockExplorerMap: { [key: string]: string } = {
  [NetworkType.Mainnet]: 'Etherscan',
  [NetworkType.Avalanche]: 'Snowscan',
  [NetworkType.AvalancheFuji]: 'Snowtrace',
  [NetworkType.Base]: 'BaseScan',
  [NetworkType.PolygonMumbai]: 'Polygonscan',
  [NetworkType.Sepolia]: 'Etherscan',
  [NetworkType.SepoliaOptimism]: 'Optimism Sepolia',
  [NetworkType.Arbitrum]: 'Arbiscan',
}

/**
 * List of acceptable assets for widget select box
 */
export const assetsList: { [key: string]: string[] } = {
  [NetworkType.Mainnet]: ['USDC', 'ETH'],
  [NetworkType.Avalanche]: ['USDC', 'AVAX'],
}

/**
 * We must keep this because there should be a "default" per network, but also a "default"
 * per product. If we then change network but haven't selected a product, this will be used
 */
export const defaultSelectedAsset: { [key: string]: string } = {
  [NetworkType.Mainnet]: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
  [NetworkType.Avalanche]: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
}

export const valueMap = {
  [NetworkType.Mainnet]: 'ETH',
  [NetworkType.Avalanche]: 'AVAX',
}

type BlockExplorer = {
  light: string
  dark: string
  hover: string
}

export const blockExplorerSymbol: { [key: number]: BlockExplorer } = {
  [NetworkType.Mainnet]: {
    light: EtherScanLight,
    dark: EtherScanDark,
    hover: EtherScanHover,
  },
  [NetworkType.Avalanche]: {
    light: SnowTraceLight,
    dark: SnowTraceDark,
    hover: SnowTraceHover,
  },
}

export const networks = [chainIdMap[NetworkType.Mainnet]]

export const networkType = (chainId: Nullable<string>): number | null => {
  if (chainId === chainHashMap[NetworkType.Mainnet]) {
    return 1
  }
  return null
}
